export default __webpack_public_path__ + "static/media/41.e3427c2e.jpeg";